/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedItems } from '../models/PagedItems';
import type { PagingQuery } from '../models/PagingQuery';
import type { ServiceCreate } from '../models/ServiceCreate';
import type { ServiceDetails } from '../models/ServiceDetails';
import type { ServiceUpdate } from '../models/ServiceUpdate';
import { request as __request } from '../core/request';

export class ServicesVService {

    /**
     * @param billingAccountId
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async servicesVGetAll(
        billingAccountId: string,
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/billing_accounts/${billingAccountId}/services/get`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param requestBody
     * @returns ServiceDetails OK
     * @throws ApiError
     */
    public static async servicesVGetExport(
        billingAccountId: string,
        requestBody?: PagingQuery,
    ): Promise<ServiceDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/billing_accounts/${billingAccountId}/services/export`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param serviceId
     * @param billingAccountId
     * @param requestBody
     * @returns ServiceDetails OK
     * @throws ApiError
     */
    public static async servicesVUpdateService(
        serviceId: string,
        billingAccountId: string,
        requestBody?: ServiceUpdate,
    ): Promise<ServiceDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/billing_accounts/${billingAccountId}/services/${serviceId}`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param serviceId
     * @returns ServiceDetails OK
     * @throws ApiError
     */
    public static async servicesVGetById(
        billingAccountId: string,
        serviceId: string,
    ): Promise<ServiceDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/billing_accounts/${billingAccountId}/services/${serviceId}`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param serviceId
     * @returns any OK
     * @throws ApiError
     */
    public static async servicesVDelete(
        billingAccountId: string,
        serviceId: string,
    ): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/v2/billing_accounts/${billingAccountId}/services/${serviceId}`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param requestBody
     * @returns ServiceDetails Created
     * @throws ApiError
     */
    public static async servicesVCreate(
        billingAccountId: string,
        requestBody?: ServiceCreate,
    ): Promise<ServiceDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/billing_accounts/${billingAccountId}/services`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

}